import PreviewSection from './preview-section';

export default PreviewSection;
